import { put, call } from 'redux-saga/effects';
import { authManager } from '../../../../core/managers';
import AuthRepository from '../../../repositories/AuthRepository';
import { Types } from './actions';
import AuthDataRepository from '../../../../data/repositories/AuthDataRepository';

export function saveCredentials(logInResponse: any) {
  authManager.setCredentials({
    token: logInResponse.token,
    refreshToken: logInResponse.refreshToken,
    userRole: logInResponse.userRole,
    userId: logInResponse.userId,
    userIdSimulated: logInResponse.userIdSimulated
  });
}

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.SIGN_IN_REQUEST });
    const authRepository: AuthRepository = new AuthDataRepository();
    const logInResponse = yield call(
      authRepository.logIn,
      action.username,
      action.password
    );
    if (!logInResponse) {
      yield put({
        type: Types.SIGN_IN_FAILURE,
        error: 'Código y/o contraseña incorrectos.'
      });
      return;
    }
    saveCredentials(logInResponse);

    yield put({ type: Types.SIGN_IN_SUCCESS, data: logInResponse });
  } catch (error) {
    yield put({
      type: Types.SIGN_IN_FAILURE,
      error: 'Código y/o contraseña incorrectos.'
    });
  }
}
